module.exports = __webpack_public_path__ + "img/service-dashujuzhengxin1.27656947.svg";